import React from "react";
import { Card, Typography, LinearProgress, Box, Grid } from "@mui/material";

const AISummaryCard = ({ aiSummaryData }) => {
  const {
    progress = 0,
    processed = 0,
    total = 0,
    keyDataPoints = {},
    missingDocuments = [],
  } = aiSummaryData || {};

  return (
    <Card
      sx={{
        p: 2,
        border: "1px solid #E6E6E6",
        backgroundColor: "#fff",
      }}
    >
      <Typography className="sub-header" fontWeight="600" mb={2}>
        AI Summary
      </Typography>

      <Typography variant="body2">Document Processing</Typography>
      <LinearProgress
        variant="determinate"
        value={progress}
        sx={{ my: 1, height: 8, borderRadius: 4 }}
      />
      <Typography variant="caption" color="textSecondary">
        {processed} of {total} documents processed
      </Typography>

      {/* Key Data Points */}
      <Box mt={3}>
        <Typography variant="body2" fontWeight="600" mb={1}>
          Key Data Points Detected
        </Typography>
        <Grid container spacing={2} justifyContent="space-between">
          <Grid item xs={6}>
            <Typography variant="body2">Revenue (2023)</Typography>
            <Typography variant="body2">Employees</Typography>
            <Typography variant="body2">Legal Entity</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body2">
              <strong>{keyDataPoints.revenue || "-"}</strong>
            </Typography>
            <Typography variant="body2">
              <strong>{keyDataPoints.employees || "-"}</strong>
            </Typography>
            <Typography variant="body2">
              <strong>{keyDataPoints.legalEntity || "-"}</strong>
            </Typography>
          </Grid>
        </Grid>
      </Box>

      {/* Missing Documents */}
      <Box mt={3}>
        <Typography
          variant="body2"
          fontWeight="500"
          sx={{ color: "#F29100" }}
          mb={1}
        >
          Missing Documents
        </Typography>
        <ul style={{ margin: 0, paddingLeft: "20px" }}>
          {missingDocuments.length > 0
            ? missingDocuments.map((doc, idx) => <li key={idx}>{doc}</li>)
            : "No missing documents"}
        </ul>
      </Box>
    </Card>
  );
};

export default AISummaryCard;
